import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import './SportIcon.css';

export default ({ sport }) => {
  // SVGs sourced from
  // https://www.flaticon.com/packs/sport-27

  const knownTypes = ['fb', 'fb_ht', 'fb_corn', 'baseball', 'basket', 'basket_ht', 'af', 'tennis', 'ih', 'cricket', 'golf', 'hr', 'mma', 'ru'];
  if (knownTypes.includes(sport)) {
    const tooltip = (
      <Tooltip id="tooltip">
        {sport}
      </Tooltip>
    );

    return (
      <OverlayTrigger
        placement="top"
        overlay={tooltip}
        trigger={['hover', 'focus', 'click']}
      >
        <div className={`SportIcon SportIcon--${sport}`}>
          <img src={`/sports/${sport}.svg`} alt={sport} />
        </div>
      </OverlayTrigger>
    );
  }

  return (
    <div className='SportIcon'>
      {sport}
    </div>);
};



// WEBPACK FOOTER //
// ./src/components/SportIcon/SportIcon.js